import {FlatList, SafeAreaView, TextInput, View} from "react-native";
import React, {useState, useEffect} from 'react'
import axios from "axios";
import Category from "../Category/Category";
import Constants from 'expo-constants';


const baseUrl = (Constants.experienceUrl == 'http://localhost:19006') ? 'https://shop2support.test' : Constants.experienceUrl;

function CategoryList(props) {
    const [hasError, setErrorFlag] = useState(false);
    const [IsLoading, setIsLoading] = useState(true);
    const [categories, setCategories] = useState(false)
    const appData = props.appData;
    const app_id = appData.app_id;
    const url = `${baseUrl}/wp-json/custom/v1/categories?post_id=${app_id}`;
    const fetchCategories = async (search = '') => {
        try {
            setIsLoading(true);
            let fetchUrl = url
            //cache buster
            fetchUrl += '&cb=' + Date.now()
            const response = await axios.get(fetchUrl);
            return response;
        } catch (error) {
            if(axios.isCancel(error)){
                console.log('Data fetching cancelled');
            }else{
                console.log(error)
                setErrorFlag(true);
                setIsLoading(false);
            }
        }
    };
    useEffect(() => {
        const source = axios.CancelToken.source();
        fetchCategories().then(response => {
            if (response.status === 200) {
                setIsLoading(false);
                setCategories(response.data.results)
                return;
            } else {
                throw new Error("Failed to fetch offers");
            }
        });
        return () => source.cancel("Data fetching cancelled");
    },[])


    function showLoading(){
        return(
            <View style={{flex:1,flexDirection:'column'}}>
                <Category loading={true}/>
                <Category loading={true}/>
                <Category loading={true}/>
                <Category loading={true}/>
                <Category loading={true}/>
                <Category loading={true}/>
                <Category loading={true}/>
                <Category loading={true}/>
                <Category loading={true}/>
                <Category loading={true}/>
            </View>
        )
    }

    function showCategoryPage(categoryID) {
        props.navigation.navigate('Home',{
            category: categoryID,
            merge: true,
        })
    }

    return (
        <SafeAreaView style={{flex:1,flexDirection:'column'}}>
            <FlatList
                style={{flex:1}}
                renderItem={({ item, index, separators }) => {
                    return(
                        <Category
                            id={item.term_id}
                            name={item.name}
                            imgsrc={item.image.url}
                            color={props.appData.theme_colour}
                            loading={IsLoading}
                            showCategory={showCategoryPage}
                            count={item.count}
                        />
                    )
                }}
                data={categories}
                keyExtractor={(item) => item.term_id}
                initialNumToRender={10}
                ListEmptyComponent={showLoading}
            >
            </FlatList>
        </SafeAreaView>
    )
}

export default CategoryList;